var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthIconLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ethereum_icon",
    "data-name": "ethereum icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.32,
    height: 23.334,
    viewBox: "0 0 15.32 23.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    fill: "#D2D4C2",
    "data-name": "Path 361",
    d: "M97.858,323.174c-.077-.1-.144-.211-.23-.306q-3.411-3.993-6.827-7.985c-.053-.062-.105-.129-.2-.244.239.086.421.148.6.211q3.217,1.192,6.439,2.384a.65.65,0,0,0,.426,0c2.355-.862,4.7-1.738,7.1-2.628-.062.081-.1.134-.134.177q-3.5,4.1-7,8.2c-.053.062-.091.134-.139.2Z",
    transform: "translate(-90.222 -299.84)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    fill: "#D2D4C2",
    "data-name": "Path 362",
    d: "M98.02,19.456c-.565.211-1.1.407-1.642.608-1.939.718-3.878,1.441-5.821,2.154a.591.591,0,0,1-.364,0q-3.626-1.336-7.253-2.681c-.072-.024-.139-.057-.239-.1,2.552-4.38,5.094-8.742,7.655-13.141C92.916,10.7,95.463,15.066,98.02,19.456Z",
    transform: "translate(-82.7 -6.3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthIconLight);
export default __webpack_public_path__ + "static/media/eth-icon-light.267e093635be7ff6d4e5584cb1d001ff.svg";
export { ForwardRef as ReactComponent };